// extracted by css-extract-rspack-plugin
export default {"wrapper":"FoundationNameWithFlag_wrapper__hnuyy"};